module.exports = __webpack_public_path__ + "img/d231ff55-3871-4a60-9211-9f2cc18020f5.f2d0d080.png";